// Core
import { loader } from 'graphql.macro';
import { useState } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { useMutationRequest } from '../../../hooks/feature/useMutationRequest';
import storage from '../../../utils/storage';
import { parseJwt } from '../../../utils/parseJwt';
import { path } from '../../../utils/routers/book';
import { Form, UseAdminSignIn } from '../types';
import { CheckPin, UseAdminCheckPin, UseAdminResendPinCode } from '../../../components/auth/types';
// Mutations
const gql = loader('./gql/mutationAdminSignIn.graphql');
const mutationAdminAuthCheckPin = loader('./gql/mutationAdminCheckPinCodeFromEmail.graphql');
const mutationResendPinCode = loader('./gql/mutationAdminSendPinCodeToEmail.graphql');

// First step auth
export const useAdminSignIn = (): UseAdminSignIn => {
  const [_adminSignIn, { data, errorText, loading }] = useMutationRequest(gql, {});

  const _signInFirstStepAuthAdmin = (form: Form): void => {
    _adminSignIn({
      variables: {
        adminLoginData: form,
      },
    });
  };

  return {
    adminFirstStepAuthLoading: loading,
    _signInFirstStepAuthAdmin,
    errorMessageFirstStepAuthAdmin: errorText,
    authorizedFirstStepAuthAdmin: data && data.adminLogin,
  };
};

// Second step auth
export const useAdminCheckPin = (): UseAdminCheckPin => {
  const [errorMessageAdmin, setErrorMessageAdmin] = useState('');

  const [_adminSignIn, { loading, data }] = useMutation(mutationAdminAuthCheckPin, {
    fetchPolicy: 'no-cache',
  });

  const _authAdminCheckPin = (form: CheckPin): void => {
    _adminSignIn({
      variables: {
        checkPinCodeData: form,
      },
    })
      .then((signInData: any) => signInData)
      .catch((error: any) => setErrorMessageAdmin(error?.graphQLErrors?.[0]?.message));
  };

  const token = data && data.adminCheckPinCodeFromEmail.access_token;
  const refresh_token = data && data.adminCheckPinCodeFromEmail.refresh_token;

  if (token) {
    const { email, id, role, lang } = parseJwt(token);
    const setUser = {
      email,
      id,
      lang,
      role,
      token,
      refresh_token,
    };
    storage.save('user', setUser);
    storage.save('lang', lang);
    window.location.assign(path.adminDashboardList);
  }
  return {
    setErrorMessageAdmin,
    _authAdminCheckPin,
    authAdminCheckPinLoading: loading,
    authAdminCheckPinError: errorMessageAdmin,
    authorizedAdmin: Boolean(token),
  };
};

// Resend PIN
export const useAdminResendPinCode = (): UseAdminResendPinCode => {
  const [_send, { data, errorText, loading }] = useMutationRequest<{ hcpSendPinCodeToEmail: {} }>(
    mutationResendPinCode,
    {},
  );
  const _resendPinCodeAdmin = (email: string): void => {
    _send({
      variables: {
        sendPinCodeData: {
          email,
        },
      },
    });
  };

  return {
    _resendPinCodeAdmin,
    dataPinCodeAdmin: data && data.hcpSendPinCodeToEmail,
    errorPinCodeAdmin: errorText,
    loadingResendPinAdmin: loading,
  };
};
